<template>
  <div
    v-for="index in computeNumberOfSkeletonLoaders"
    :key="index"
  >
    <SkeletonLoader class="vp-file-upload cursor-wait" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import SkeletonLoader from '@/components/SkeletonLoader.vue';
interface Props {
  attachmentLength: number;
}
const props = withDefaults(defineProps<Props>(), { attachmentLength: 1 });
const computeNumberOfSkeletonLoaders = computed(() => {
  if (props.attachmentLength <= 1) {
    return 1;
  }
  return props.attachmentLength <= 3 ? props.attachmentLength + 1 : 4;
});
</script>
